module.exports = __webpack_public_path__ + "static/media/helmholtz.83a97ed9.png";